import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { logoutUser } from '../../../actions/userActions';
import ModalBox from '../../../themes/overrides/ModalBox';
import { Modal } from '@mui/material';
import { Logout } from '@mui/icons-material';

const AuthLogout = ({ children, onClick }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleLogoutClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirmLogout = () => {
        dispatch(logoutUser());
        navigate('/login');
        if (onClick) onClick();
        setOpen(false);
    };

    return (
        <>
            <div onClick={handleLogoutClick} style={{ cursor: 'pointer' }}>
                {children}
            </div>
            <Modal open={open} onClose={handleClose}>
                <ModalBox sx={{ width: '520px', maxWidth: '95%' }}>
                    <Stack spacing={2}>
                        <p>Are you sure you want to logout?</p>
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button variant="outlined" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button variant="contained" onClick={handleConfirmLogout}>
                                <Logout sx={{ marginRight: 1 }} />
                                Logout
                            </Button>
                        </Stack>
                    </Stack>
                </ModalBox>
            </Modal>
        </>
    );
};

export default AuthLogout;